import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	createHeartbeatButton: {
		id: 'eoc.heartbeats.empty-state.primary-action.no-translate',
		defaultMessage: 'Create heartbeat',
		description: 'Text of primary empty state button used to create heartbeat.',
	},
});

export default messages;
